import React from 'react';
import { T0TouchableOpacity as Button } from '../../../components/forms/overrides';
import { useCartsMutations } from '../../../api/hooks/vendor/carts/use-carts-mutations';
import { useT } from '../../../utils/helper';
import { usePrintService } from '../../../hooks/use-print-service.hook';

interface OrderSummaryActionButtonsProps {
  print_prep_ticket_path?: string;
}

export const OrderSummaryActionButtons = (
  props: OrderSummaryActionButtonsProps,
) => {
  const t = useT('cashRegister');
  const { printReceipt } = useCartsMutations();
  const printService = usePrintService();

  if (!props.print_prep_ticket_path) {
    return null;
  }

  const handlePrintReceipt = async () => {
    const request = printReceipt.mutateAsync(props.print_prep_ticket_path!);

    printService.fetchAndExecutePrintJobs(request);
  };

  return (
    <Button
      onPress={handlePrintReceipt}
      label={t('printPrepTicket')}
      extraStyle="py-5 px-3"
    />
  );
};
